import React from 'react';

export const getPositionColor = (positionName: string | undefined): string => {
  switch (positionName?.toUpperCase()) {
    case 'STNA':
      return 'bg-[#FCE8D9] text-[#E67E34]'; // orange100, orange500
    case 'RN':
      return 'bg-[#E0E8ED] text-[#4A6FA5]'; // blue100, blue500
    case 'LPN':
      return 'bg-[#E0EDE2] text-[#3A7D44]'; // green100, green600
    default:
      return 'bg-[#F8FAFC] text-[#677D94]'; // card1, primaryLight
  }
};

export const getPositionStyles = (positionName: string | undefined): {
  lightBg: string;
  badge: string;
  text: string;
  border: string;
  mainBg?: string;
} => {
  switch (positionName?.toUpperCase()) {
    case 'STNA':
      return {
        lightBg: 'bg-[#FCE8D9]', // orange100
        badge: 'bg-[#E67E34] text-white', // orange500
        text: 'text-[#E67E34]', // orange500
        border: 'border-[#E67E34]', // orange500
        mainBg: 'linear-gradient(to right, #E67E34, #BF5A1F)', // orange500 to orange800
      };
    case 'RN':
      return {
        lightBg: 'bg-[#E0E8ED]', // blue100
        badge: 'bg-[#4A6FA5] text-white', // blue500
        text: 'text-[#4A6FA5]', // blue500
        border: 'border-[#4A6FA5]', // blue500
        mainBg: 'linear-gradient(to right, #4A6FA5, #1A334C)', // blue500 to blue900
      };
    case 'LPN':
      return {
        lightBg: 'bg-[#E0EDE2]', // green100
        badge: 'bg-[#3A7D44] text-white', // green600
        text: 'text-[#3A7D44]', // green600
        border: 'border-[#3A7D44]', // green600
        mainBg: 'linear-gradient(to right, #3A7D44, #2E6B3A)', // green600 to green800
      };
    default:
      return {
        lightBg: 'bg-[#F8FAFC]', // card1
        badge: 'bg-[#677D94] text-white', // primaryLight
        text: 'text-[#677D94]', // primaryLight
        border: 'border-[#677D94]', // primaryLight
        mainBg: 'linear-gradient(to right, #677D94, #2A333C)', // primaryLight to primary
      };
  }
};

export const getApplicationStatusColor = (status: string | undefined): string => {
  switch (status?.toUpperCase()) {
    case 'PENDING':
      return 'bg-[#FFF8E6] text-[#D4A123]'; // yellow100, yellow800
    case 'APPROVED':
    case 'ACCEPTED':
    case 'SELECTED':
    case 'CONFIRMED':
      return 'bg-[#E0EDE2] text-[#3A7D44]'; // green100, green600
    case 'REJECTED':
    case 'WITHDRAWN':
      return 'bg-[#FFEAEA] text-[#C84648]'; // red100, red500
    default:
      return 'bg-[#F8FAFC] text-[#677D94]'; // card1, primaryLight
  }
};

export const getOpeningStatusInfo = (status: string | undefined): {
  text: string;
  color: string;
  textColor?: string;
  icon?: React.ElementType;
} => {
  switch (status?.toUpperCase()) {
    case 'ACTIVE':
      return { text: 'ACTIVE', color: 'bg-[#E0EDE2]', textColor: 'text-[#3A7D44]' }; // green100, green600
    case 'FILLED':
    case 'CONFIRMED':
    case 'SELECTED':
    case 'COMPLETED':
      return { text: 'FILLED', color: 'bg-[#E0E8ED]', textColor: 'text-[#4A6FA5]' }; // blue100, blue500
    case 'CANCELLED':
      return { text: 'CANCELLED', color: 'bg-[#FFEAEA]', textColor: 'text-[#C84648]' }; // red100, red500
    default:
      return { text: status?.toUpperCase() || 'UNKNOWN', color: 'bg-[#F8FAFC]', textColor: 'text-[#677D94]' }; // card1, primaryLight
  }
};

export const getInitials = (firstName?: string, lastName?: string): string => {
  const first = firstName?.[0]?.toUpperCase() || '';
  const last = lastName?.[0]?.toUpperCase() || '';
  return `${first}${last}` || 'N/A';
};